<script setup lang="ts">
const teamMembers = [
  {
    role: 'Locatie',
    title: 'In en rond Zemst',
    description: 'Onze kampen vinden plaats in en rond Zemst en onze zwemlessen gaan door in Mechelen.',
    icon: '/images/tspeelfabrik/fabrik.svg',
    color: '#F27063',
    buttonText: '',
    buttonLink: '#',
  },
  {
    role: 'Monitoren',
    title: 'Gediplomeerde monitoren',
    description: 'Ons toegewijd team van ervaren en gediplomeerde monitoren zorgt keer op keer voor een veilige en leuke tijd.',
    icon: '/images/tspeelfabrik/asterix.svg',
    color: '#F27063',
    buttonText: 'Ontdek ons team',
    buttonLink: '#',
  },
  {
    role: 'Doelgroep',
    title: 'Voor alle kleuters & kinderen',
    description: 'Van de instapklas (2,5 jaar) tot en met het 4de leerjaar, iedereen is welkom! Omdat we vol inzetten op sport, plezier en spel vragen we wel dat je kind zindelijk is.',
    icon: '/images/tspeelfabrik/tandwiel1.svg',
    color: '#F27063',
    buttonText: 'Ontdek onze activiteiten',
    buttonLink: '#',
  },
  {
    role: 'Activiteiten',
    title: 'Meer dan enkel kampen',
    description: 'Naast kampen organiseren we ook zwemlessen en feestelijke activiteiten.',
    icon: '/images/tspeelfabrik/tandwiel3.svg',
    color: '#F27063',
    buttonText: 'Ontdek \'t SpeelFabrik',
    buttonLink: '#',
  },
]
</script>

<template>
  <div id="team" class="team-section">
    <VContainer>
      <div class="section-header text-center mb-12">
        <div class="section-badge">
          Wie zijn wij?
        </div>
        <h2 class="section-title">
          't SpeelFabrik: een nieuwe vzw met een missie
        </h2>
        <p class="section-description">
          't SpeelFabrik is een nieuwe vzw die met veel enthousiasme speelse activiteiten organiseert in en rond Zemst.
          Wij bieden een veilige en leuke omgeving waar kinderen van de instapklas tot en met het 4de leerjaar
          zich kunnen uitleven, nieuwe vrienden maken en onvergetelijke herinneringen creëren.
        </p>
      </div>

      <VRow class="team-grid">
        <VCol v-for="member in teamMembers" :key="member.role" cols="12" md="6">
          <div class="team-item">
            <div class="team-icon">
              <img :src="member.icon" :alt="member.role" class="icon-image" width="120" height="120">
            </div>
            <div class="team-content">
              <div class="team-role" :style="{ color: member.color }">
                {{ member.role }}
              </div>
              <h4 class="team-title">
                {{ member.title }}
              </h4>
              <p class="team-description">
                {{ member.description }}
              </p>
            </div>
          </div>
        </VCol>
      </VRow>
    </VContainer>
  </div>
</template>

<style lang="scss" scoped>
.team-section {
  position: relative;
  overflow: hidden;
  background: rgb(var(--v-theme-background));
  padding-block: 4rem;
}

.section-header {
  .section-badge {
    display: inline-flex;
    align-items: center;
    border-radius: 8px;
    background: #f26f631a;
    color: #f27063;
    font-weight: 600;
    gap: 0.5rem;
    letter-spacing: 0.5px;
    margin-block-end: 1rem;
    padding-block: 0.5rem;
    padding-inline: 1.5rem;
    text-transform: uppercase;
  }

  .section-title {
    color: #2c3e50;
    font-size: clamp(1.75rem, 4vw, 2.5rem);
    font-weight: 700;
    line-height: 1.2;
    margin-block-end: 1.5rem;
  }

  .section-description {
    color: #546e7a;
    font-size: 1.125rem;
    line-height: 1.6;
    margin-inline: auto;
    max-inline-size: 800px;
  }
}

.team-grid {
  margin-block-end: 2rem;
}

.team-item p{
  padding: 0;
}

.team-item {
  display: flex;
  align-items: flex-start;
  padding: 1.5rem;
  border-radius: 16px;
  background: white;
  block-size: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 8%);
  gap: 1rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 12%) !important;
    transform: translateY(-4px);
  }

  .team-icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: 12px;

    // background-color: rgba(var(--v-theme-primary), 0.12);
    block-size: 64px;
    inline-size: 44px;
    transition: transform 0.3s ease;

    .icon-image {
      block-size: 54px;
      filter: invert(48%) sepia(65%) saturate(1478%) hue-rotate(329deg) brightness(97%) contrast(92%);
      inline-size: 34px;
      object-fit: contain;
    }

    .v-icon {
      color: rgb(var(--v-theme-primary));
    }

    &:hover {
      transform: scale(1.1);
    }
  }

  .team-content {
    flex: 1;

    .team-role {
      font-size: 1rem;
      font-weight: 600;
      letter-spacing: 0.5px;
      margin-block-end: 0.375rem;
      text-transform: uppercase;
    }

    .team-title {
      color: #2c3e50;
      font-size: 1.125rem;
      font-weight: 700;
      margin-block-end: 0.375rem;
    }

    .team-description {
      color: #546e7a;
      line-height: 1.5;
    }
  }
}

.custom-read-more-btn {
  border-color: rgb(var(--v-theme-primary)) !important;
  background-color: transparent !important;
  color: rgb(var(--v-theme-primary)) !important;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgb(var(--v-theme-primary)) !important;
    color: white !important;
  }
}

.team-strip-section {
  position: relative;
  overflow: hidden;
  background: rgb(var(--v-theme-background));
  padding-block: 2rem 4rem;
}

.team-strip-container {
  margin-inline: auto;
  max-inline-size: 1400px;
}

.team-strip {
  border-radius: 16px;
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 8%);
  inline-size: 90%;
  margin-inline: auto;
  padding-block: 2rem;
  padding-inline: 2rem;
}

.team-strip-row {
  row-gap: 1rem;
}

.team-strip-item {
  display: flex;
  align-items: center;
  border-radius: 8px;
  gap: 1rem;
  padding-block: 0.75rem;
  padding-inline: 0.75rem;
  transition: all 0.3s ease;
}

.team-strip-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: transparent;
  block-size: 56px;
  inline-size: 56px;
}

.team-strip-icon-image {
  block-size: 40px;
  filter: invert(48%) sepia(65%) saturate(1478%) hue-rotate(329deg) brightness(97%) contrast(92%);
  inline-size: 40px;
  object-fit: contain;
  opacity: 0.85;
  transition: all 0.3s ease;
}

.team-strip-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.team-strip-title {
  color: rgba(44, 62, 80, 85%);
  font-size: 0.95rem;
  font-weight: 700;
  transition: color 0.3s ease;
}

.team-strip-item:hover {
  transform: translateY(-2px);

  .team-strip-icon-image {
    opacity: 1;
    transform: scale(1.05);
  }

  .team-strip-title {
    color: rgba(44, 62, 80, 100%);
  }
}

.team-strip-description {
  color: rgba(84, 110, 122, 80%);
  font-size: 0.85rem;
  line-height: 1.4;
}

@media (max-width: 960px) {
  .team-section {
    padding-block: 3rem;
  }

  .team-strip {
    padding: 1rem;
  }

  .content-col .content-wrapper {
    padding: 1rem;
  }

  .image-col {
    margin-block-start: 2rem;

    .image-wrapper {
      padding: 1rem;
    }
  }
}
</style>
